import api from './api';

let cachedRideTypes = null;

// Real car images for ride types - Professional, clear vehicle shots
export const RIDE_TYPE_IMAGES = {
  standard: 'https://images.unsplash.com/photo-1758219751327-03957f9dc933?w=200&h=120&fit=crop&auto=format',  // White sedan driving
  xl: 'https://images.unsplash.com/photo-1653641305372-a084f9b78858?w=200&h=120&fit=crop&auto=format',  // Black Range Rover SUV
  lux: 'https://images.unsplash.com/photo-1749453841570-c6caeccd9ab7?w=200&h=120&fit=crop&auto=format',  // Black Mercedes under palms
  shared: 'https://images.unsplash.com/photo-1763604993367-c92cbf4efc57?w=200&h=120&fit=crop&auto=format',  // Fiat 500 compact
  motorbike: 'https://images.unsplash.com/photo-1711435470785-4e1146a16dcc?w=200&h=120&fit=crop&auto=format',  // Red motorcycle
};

export const fetchRideTypes = async () => {
  if (cachedRideTypes) {
    return cachedRideTypes;
  }
  
  try {
    const response = await api.get('/ride-types');
    // Add images to fetched ride types
    const rideTypesWithImages = response.data.rideTypes.map(type => ({
      ...type,
      image: RIDE_TYPE_IMAGES[type.id] || RIDE_TYPE_IMAGES.standard
    }));
    cachedRideTypes = rideTypesWithImages;
    return cachedRideTypes;
  } catch (error) {
    console.error('Error fetching ride types:', error);
    // Return fallback mock data with images
    return [
      {
        id: 'standard',
        name: 'Tekstar',
        description: 'Affordable, everyday rides',
        capacity: 4,
        icon: '🚗',
        image: RIDE_TYPE_IMAGES.standard,
        priceMultiplier: 1,
        eta: '2-5 min',
      },
      {
        id: 'xl',
        name: 'Tekstar XL',
        description: 'Affordable rides for groups up to 6',
        capacity: 6,
        icon: '🚙',
        image: RIDE_TYPE_IMAGES.xl,
        priceMultiplier: 1.5,
        eta: '3-7 min',
      },
      {
        id: 'lux',
        name: 'Lux',
        description: 'Premium rides in luxury vehicles',
        capacity: 4,
        icon: '🚘',
        image: RIDE_TYPE_IMAGES.lux,
        priceMultiplier: 2.2,
        eta: '5-10 min',
      },
      {
        id: 'shared',
        name: 'Shared',
        description: 'Share the ride, split the cost',
        capacity: 2,
        icon: '👥',
        image: RIDE_TYPE_IMAGES.shared,
        priceMultiplier: 0.7,
        eta: '3-8 min',
      },
    ];
  }
};

export const calculatePrice = async (pickup, dropoff, rideTypeId) => {
  try {
    const response = await api.post('/rides/calculate-price', {
      pickup,
      dropoff,
      rideTypeId,
    });
    return response.data;
  } catch (error) {
    console.error('Error calculating price:', error);
    // Fallback calculation
    const basePrice = 3.50;
    const perMile = 1.80;
    const distance = Math.random() * 10 + 2;
    const rideTypes = await fetchRideTypes();
    const rideType = rideTypes.find(rt => rt.id === rideTypeId);
    const multiplier = rideType?.priceMultiplier || 1;
    
    return {
      distance: distance.toFixed(1),
      duration: Math.max(5, parseInt((distance / 30) * 60)),
      price: ((basePrice + (distance * perMile)) * multiplier).toFixed(2),
    };
  }
};